import { render, staticRenderFns } from "./CancelNotice.vue?vue&type=template&id=624fb4c2&scoped=true&"
import script from "./CancelNotice.vue?vue&type=script&lang=js&"
export * from "./CancelNotice.vue?vue&type=script&lang=js&"
import style0 from "./CancelNotice.vue?vue&type=style&index=0&id=624fb4c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624fb4c2",
  null
  
)

export default component.exports